// src/components/Footer.js (Giao diện FLC Group)

import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import LogoImage from "../../assets/img/logo1.png";
const Footer = () => {
  return (
    <footer className="flc-footer">
      {}
      <div className="footer__upper-section">
        <div className="footer__content-wrapper">
          {}
          <div className="footer__col footer__contact">
            <h4 className="footer__heading">
              CÔNG TY CỔ PHẦN XÂY DỰNG VÀ CƠ ĐIỆN  HABAKO 
            </h4>
            <p>Trụ sở chính: Thôn 3, Xã Nam Phù , Thành Phố Hà Nội, Việt Nam</p>
            <p>Hotline: 0866306661</p>
            <p>Email: info@habakome.com</p>

            {}
            <div className="social-icons flc-style">
              {}
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                FB
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                IN
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                YT
              </a>
              <a
                href="https://zalo.me"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                ZA
              </a>
            </div>
          </div>

          {}
          <div className="footer__col footer__links-group">
            <h4 className="footer__heading">LIÊN KẾT NHANH</h4>
            <ul>
              <li>
                <Link to="/ve-chung-toi">Về Chúng Tôi</Link>
              </li>
              <li>
                <Link to="/dich-vu">Dịch Vụ M&E</Link>
              </li>
              <li>
                <Link to="/du-an">Dự Án Tiêu Biểu</Link>
              </li>
              <li>
                <Link to="/lien-he">Liên Hệ & Tuyển Dụng</Link>
              </li>
            </ul>
          </div>

          {}
          <div className="footer__col footer__policy-links">
            <h4 className="footer__heading">CHÍNH SÁCH</h4>
            <ul>
              <li>
                <Link to="/chinh-sach-bao-mat">Chính sách Bảo mật</Link>
              </li>
              <li>
                <Link to="/dieu-khoan">Điều khoản sử dụng</Link>
              </li>
              <li>
                <Link to="/faqs">Hỏi đáp (FAQs)</Link>
              </li>
            </ul>
          </div>
          {}
          <div className="footer__col footer__newsletter">
            <h4 className="footer__heading">ĐĂNG KÝ NHẬN TIN</h4>
            <p>Nhận các thông tin mới nhất về dự án và công nghệ M&E.</p>
            <div className="newsletter-form">
              <input type="email" placeholder="Nhập địa chỉ email của bạn" />
              <button>Đăng ký</button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="footer__bottom-section">
        <div className="footer__bottom-wrapper">
          {}
          <div className="footer__logo-area">
            {}
            <img
              src={LogoImage}
              alt="Habako M&E Logo"
              className="footer__logo"
            />
          </div>

          {}
          <div className="footer__copyright">
            <p>
              © {new Date().getFullYear()} Công ty Cổ phần Xây Dựng và Cơ Điện  Habako
              . Đã đăng ký bản quyền.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
